<template>
  <div v-if="isUpdated && files && files.length" class="p-file-preview-area">
    <div v-for="file in files"
         :key="`file-preview-area-item-${getFileGuid(file)}`"
         class="p-file-preview-area__item">
      <p-file-preview
        :file="file"
        :height="filePreviewSize"
        :width="filePreviewSize"
        class="file"
      ></p-file-preview>
      <v-text-field
        :disabled="disabled"
        :label="$t('components.filePreviewArea.title')"
        v-if="filesDataByGuid[getFileGuid(file)]"
        v-model="filesDataByGuid[getFileGuid(file)].title"
        autocomplete="off"
        clearable
        dense
        class="title"
        @input="oninput"
      ></v-text-field>
      <v-text-field
        :disabled="disabled"
        :label="$t('components.filePreviewArea.description')"
        v-if="filesDataByGuid[getFileGuid(file)]"
        v-model="filesDataByGuid[getFileGuid(file)].text"
        autocomplete="off"
        clearable
        dense
        class="text"
        @input="oninput"
      ></v-text-field>
    </div>
  </div>
</template>


<script>
import eventBus from '@/eventBus'

import fileMixin from '@/mixins/file.mixin'
import objectMixin from '@/mixins/object.mixin'

import PFilePreview from './PFilePreview'


export default {
  components: {
    PFilePreview
  },


  props: {
    files: {
      type: Array,
      default: () => []
    },
    filePreviewSize: {
      type: Number,
      default: 100
    },
    cssClass: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isMain: {
      type: Boolean,
      default: false
    }
  },


  mixins: [
    fileMixin,
    objectMixin
  ],


  data () {
    return {
      filesDataByGuidCustom: {},
      isUpdated: false
    }
  },


  computed: {
    filesDataByGuid () {
      return this.disabled ? eventBus.filesDataByGuidDefault : this.filesDataByGuidCustom
    }
  },


  watch: {
    files () {
      this.updateFilesData()
    }
  },

  methods: {
    oninput () {
      this.updateFilesData()
      eventBus.$emit('filesDataUpdated')
    },

    updateFilesData () {
      this.isUpdated = false

      const filesDataByGuidCustomNew = {}
      if (this.files?.length) {
        this.files.forEach(file => {
          const guid = this.getFileGuid(file)
          filesDataByGuidCustomNew[guid] = {}

          if (this.filesDataByGuidCustom[guid] && this.filesDataByGuidCustom[guid].title) {
            filesDataByGuidCustomNew[guid].title = this.filesDataByGuidCustom[guid].title
          } else if (file.title) {
            filesDataByGuidCustomNew[guid].title = file.title
          } else if (eventBus?.filesDataByGuidDefault && eventBus.filesDataByGuidDefault[guid] && eventBus.filesDataByGuidDefault[guid].title) {
            filesDataByGuidCustomNew[guid].title = eventBus.filesDataByGuidDefault[guid].title
          } else {
            filesDataByGuidCustomNew[guid].title = ''
          }

          if (this.filesDataByGuidCustom[guid] && this.filesDataByGuidCustom[guid].text) {
            filesDataByGuidCustomNew[guid].text = this.filesDataByGuidCustom[guid].text
          } else if (typeof file.text === 'string' && file.text) {
            filesDataByGuidCustomNew[guid].text = file.text
          } else if (eventBus?.filesDataByGuidDefault && eventBus.filesDataByGuidDefault[guid] && eventBus.filesDataByGuidDefault[guid].text) {
            filesDataByGuidCustomNew[guid].text = eventBus.filesDataByGuidDefault[guid].text
          } else {
            filesDataByGuidCustomNew[guid].text = ''
          }
        })
        this.filesDataByGuidCustom = this.getObjectCopy(filesDataByGuidCustomNew)
      } else {
        this.filesDataByGuidCustom = {}
      }

      if (this.isMain) {
        eventBus.filesDataByGuidDefault = this.getObjectCopy(this.filesDataByGuidCustom)
        eventBus.$emit('mainFilesDataUpdated')
      }

      this.isUpdated = true
    }
  },

  created () {
    this.updateFilesData()
    if (!this.isMain) {
      eventBus.$on('mainFilesDataUpdated', () => {
        this.updateFilesData()
      })
    }
  }
}
</script>
